/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/processes';
const stepsPathname = '/steps';
const stepPropertiesPathname = '/step-properties';

export const ProcessApi = {
  findWithEntity: async (option: FindOptions) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createStep: async (body: any) => {
    try {
      const response = await entityService.post(stepsPathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createMultiStep: async (body: any) => {
    try {
      const response = await entityService.post(`${stepsPathname}/multi`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStep: async (id: string, body: any = {}) => {
    const url = `${stepsPathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createStepProperty: async (body: any) => {
    try {
      const response = await entityService.post(stepPropertiesPathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStepProperty: async (id: string, body: any = {}) => {
    const url = `${stepPropertiesPathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeStepProperty: async (id: string) => {
    const url = `${stepPropertiesPathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateProcessCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async (option: GenerateProcessCodeQuery) => {
    let url = `${pathname}/generate-code`;
    const query = serialize(option);
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface CheckDuplicateProcessCodeQuery {
  code: string;
  entityID?: string;
}

export interface GenerateProcessCodeQuery {
  entityID?: string;
}
